import { createContext } from "react";
import { IUserInfo } from "../utils/types";

interface IUserDataContext {
  userInfo: IUserInfo;
  refetchStatus: () => Promise<void>;
}

export const UserDataContext = createContext<IUserDataContext>({
  userInfo: {},
  refetchStatus: async () => {},
});
